﻿<template>
    <validation-provider :name="name" :rules="validateRules" v-slot="validation" mode="eager" slim>
        <div class="form-group" v-bind:class="{'has-error': validation.invalid && validation.validated}">
            <label :for="'input'+_uid" :class="styleLabel">{{name}}</label>
            <div :class="styleInput">
                <div v-if="required" class="input-group">
                    <select v-model="internalValue" class="form-control" ref="input" :id="'input'+_uid" :name="'input'+_uid" v-bind:class="{'has-error': validation.invalid && validation.validated }">
                        <option :value="emptyValue" v-if="displayEmpty && !emptyTitle">--- Select {{name}} ---</option>
                        <option :value="emptyValue" v-if="displayEmpty && emptyTitle">{{emptyTitle}}</option>
                        <option v-for="option in options" :value="option.Value">{{ option.Text }}</option>
                    </select>
                    <div class="input-group-append">
                        <span class="input-group-text"><i class="fas fa-asterisk" title="Required Field"></i></span>
                    </div>
                </div>
                <select v-if="!required" v-model="internalValue" class="form-control" ref="input" :id="'input'+_uid" :name="'input'+_uid"  v-bind:class="{'has-error': validation.invalid && validation.validated }">
                    <option :value="emptyValue" v-if="displayEmpty && !emptyTitle">--- Select {{name}} ---</option>
                    <option :value="emptyValue" v-if="displayEmpty && emptyTitle">{{emptyTitle}}</option>
                    <option v-for="option in options" :value="option.Value">{{ option.Text }}</option>
                </select>
                <span class="invalid-feedback d-block" v-for="err in validation.errors">{{err}}</span>
            </div>
        </div>
    </validation-provider>
</template>

<script>    
    module.exports =
        {
            components: {                
                validationProvider: VeeValidate.ValidationProvider
            },
            props: {
                name: {
                    type: String,
                    required: true
                },
                value: {
                    type: Number
                },
                options: {
                    type: Array,
                    default: []
                },
                required: {
                    type: Boolean,
                    default: false
                },
                emptyTitle: {
                    type: String,
                    required: false
                },
                emptyValue: {
                    type: Number,
                    default: -1
                },
                labelCols: {
                    type: Number,
                    default: 4
                },
                displayEmpty: {
                    type: Boolean,
                    default: true
                }
            },
            computed: {
                validateRules: function () {
                    let res = {};
                    if (this.required) {
                        res = { NotEqual: this.emptyValue };
                    }
                    return res;
                },
                styleLabel: function () {
                    if (this.labelCols > 0) {
                        return 'col-sm-' + this.labelCols + ' control-label';
                    }
                    return 'control-label';
                },
                styleInput: function () {
                    if (this.labelCols > 0) {
                        return 'col-sm-' + (12 - this.labelCols);
                    }
                    return '';
                },
                internalValue: {
                    get: function() {
                        if (this.value === undefined || this.value === null || isNaN(this.value)) {
                            return '';
                        }
                        return String(this.value);
                    },
                    set: function(val) {
                        var formattedValue = parseInt(val);
                        if (Number.isNaN(formattedValue)) {
                            formattedValue = undefined;
                        }
                        this.$emit('input', formattedValue);
                    }
                }
            }
        }
</script>